import React from 'react';
import { Menu, Grid } from 'antd';
import { DashboardOutlined, UnorderedListOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';

import { HorizontalMenuWrapper } from './style';

const { useBreakpoint } = Grid;

const TopMenu = ({ darkMode }) => {
    const screens = useBreakpoint();
    const isMobile = !screens.md;
    const location = useLocation();

    const currentMenu = [
        {
            key: 'dashboard',
            icon: <DashboardOutlined />,
            label: <Link to="/dashboard">Dashboard</Link>,
        },
        {
            key: 'quick-actions',
            icon: <ThunderboltOutlined />,
            label: <Link to="/quick-actions">Quick Actions</Link>,
        },
        {
            key: 'history',
            icon: <UnorderedListOutlined />,
            label: <Link to="/history">History</Link>,
        }
    ];

    const mobileMenu = [
        {
            key: 'dashboard',
            icon: <DashboardOutlined style={{ fontSize: '20px' }} />,
            label: 'Dashboard',
            path: '/dashboard'
        },
        {
            key: 'quick-actions',
            icon: (
                <span className="quick-action-icon">
                    <ThunderboltOutlined style={{ fontSize: '20px' }} />
                </span>
            ),
            label: 'Quick Actions',
            path: '/quick-actions'
        },
        {
            key: 'history',
            icon: <UnorderedListOutlined style={{ fontSize: '20px' }} />,
            label: 'History',
            path: '/history'
        }
    ];

    const currentPath = location.pathname.split('/').filter(Boolean).shift() || '';
    const matchedKey = currentPath === 'HistoryDetail' ? 'history' : (mobileMenu.find(item => location.pathname.toLowerCase().startsWith(item.path))?.key || '');

    return (
        <HorizontalMenuWrapper darkMode={darkMode} style={{ width: '100%' }}>
            {isMobile ? (
                <div style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '56px',
                    backgroundColor: '#ffffff',
                    borderTop: '1px solid #e8e8e8',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    zIndex: 1000,
                    boxShadow: '0 -2px 12px rgba(0,0,0,0.08)',
                    padding: '4px 0'
                }}>
                    {mobileMenu.map(item => {
                        const isActive = matchedKey === item.key;
                        return (
                            <Link 
                                key={item.key} 
                                to={item.path} 
                                style={{ 
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    alignItems: 'center', 
                                    justifyContent: 'center',
                                    color: isActive ? '#f58826' : '#8c8c8c',
                                    textDecoration: 'none',
                                    fontSize: '11px',
                                    fontWeight: isActive ? '600' : '400',
                                    position: 'relative',
                                    width: '33.33%',
                                    transition: 'color 0.2s ease'
                                }}
                            >
                                <div style={{ 
                                    marginBottom: '3px', 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'center',
                                    position: 'relative',
                                    color: isActive ? '#f58826' : '#8c8c8c'
                                }}>
                                    {item.icon}
                                </div>
                                <span style={{ fontSize: '10px', lineHeight: '1.1', }}>{item.label}</span>
                            </Link>
                        );
                    })}
                </div>
            ) : (
                <Menu mode="horizontal" selectedKeys={[matchedKey]} items={currentMenu} className="top-menu" style={{ width: '90%' }} />
            )}

            <style>{`
                .quick-action-icon {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                }
                @media only screen and (max-width: 768px) {
                    body {
                        padding-bottom: 56px !important;
                    }
                    .ant-layout-content {
                        padding-bottom: 76px !important;
                    }
                    .admin-footer {
                        padding-bottom: 76px !important;
                    }
                }
            `}</style>
        </HorizontalMenuWrapper>
    );
};

export default TopMenu;
